<template>
  <div :class="$style.container" @click="handleClick" title="Back to call">
    <div :class="$style.inner">
       <img :src="photoUrl" :alt="name" />
      <p>{{name}}</p>
    </div>
    <div :class="$style.inner">
      <p>Back to call</p>
      <img src="../../../../assets/img/angle-right.svg" alt="Back" />
    </div>
  </div>
</template>

<script>
  export default {
    props: ['name', 'photoUrl'],
    methods: {
      handleClick () {
        this.$emit('click')
      }
    }
  }
</script>

<style module lang="less" src="./back-to-call.less"></style>



// WEBPACK FOOTER //
// back-to-call.vue?221b5660